import React from 'react';

import EmployeeLoginLink from './EmployeeLoginLink';
import { BUSINESS, DELIVERY, fullAddress } from './businessInfo';
import { INFO_PAGES, INFO_PAGE_ORDER, InfoPanel } from './infoPages';
import ChenthoorLogo from '../../../assets/images/Chenthoor_landscape_Logo-removebg-preview.png';

// The foot of the special order page, which is where a guest lands — nobody has
// signed in, so this is the whole site as far as they are concerned. It ends the
// way a home page ends: who we are, how to reach us, and every policy page
// spelled out as a link rather than hidden behind the corner menu's three lines.
// A payment gateway reviewer looks for exactly that in a footer.
//
// The pages open in the shared panel over the order page, so a customer reading
// the refund policy does not lose their cart.

const telHref = (number) => 'tel:' + String(number).replace(/[^\d+]/g, '');

// Only what the business actually has: an empty field is left out here rather
// than shown as a "[to be filled in]" marker. The information pages carry those
// markers, and that is where a gap has to be caught — a footer full of them
// would be the first thing a customer reads.
const SpecialOrderFooter = () => {
    const [page, setPage] = React.useState(null);
    const address = fullAddress();

    return (
        <>
            <footer className="so-footer">
                <div className="so-footer__inner">
                    <div className="so-footer__brand">
                        <img src={ChenthoorLogo} alt={BUSINESS.fullName} className="so-footer__logo" />
                        <p className="so-footer__tagline">{BUSINESS.tagline}</p>
                        <p className="so-footer__blurb">
                            Order ahead for the date you want it — delivered to your door or
                            collected from the restaurant. Special orders need
                            {' '}{DELIVERY.preOrderNoticeHours} hours' notice.
                        </p>
                    </div>

                    <nav className="so-footer__col" aria-label="Information">
                        <h3 className="so-footer__heading">Information</h3>
                        <ul className="so-footer__links">
                            {INFO_PAGE_ORDER.map((key) => (
                                <li key={key}>
                                    <button
                                        type="button"
                                        className="so-footer__link"
                                        onClick={() => setPage(key)}
                                    >
                                        {INFO_PAGES[key].title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="so-footer__col">
                        <h3 className="so-footer__heading">Reach us</h3>
                        <ul className="so-footer__contact">
                            {BUSINESS.phone && (
                                <li>
                                    <i className="pi pi-phone" />
                                    <a href={telHref(BUSINESS.phone)}>{BUSINESS.phone}</a>
                                </li>
                            )}
                            {BUSINESS.email && (
                                <li>
                                    <i className="pi pi-envelope" />
                                    <a href={'mailto:' + BUSINESS.email}>{BUSINESS.email}</a>
                                </li>
                            )}
                            {address && (
                                <li>
                                    <i className="pi pi-map-marker" />
                                    <span>{address}</span>
                                </li>
                            )}
                            {BUSINESS.hours && (
                                <li>
                                    <i className="pi pi-clock" />
                                    <span>{BUSINESS.hours}</span>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <div className="so-footer__legal">
                    <p>
                        © {new Date().getFullYear()} {BUSINESS.fullName}. All rights reserved.
                    </p>
                    {/* Also at the top of the page — an employee should not have to
                        scroll the menu to find it, and a customer reading the footer
                        should not trip over it. */}
                    <EmployeeLoginLink className="so-footer__staff" />
                    {(BUSINESS.fssai || BUSINESS.gstin) && (
                        <p className="so-footer__ids">
                            {BUSINESS.fssai && <span>FSSAI {BUSINESS.fssai}</span>}
                            {BUSINESS.gstin && <span>GSTIN {BUSINESS.gstin}</span>}
                        </p>
                    )}
                </div>
            </footer>

            <InfoPanel pageKey={page} onClose={() => setPage(null)} />
        </>
    );
};

export default SpecialOrderFooter;
